import React from 'react'
import hoistNonReactStatic from 'hoist-non-react-statics'
import { getComponentName } from 'tools/react'
import { Router, parseUrl } from 'tools/routes'

export const RouteContext = React.createContext({ route: {} })

export const useRoute = () => {
  const { route } = React.useContext(RouteContext)
  return route
}

const withRoute = (Component) => {
  const ComponentWithRoute = React.forwardRef((props, ref) => {
    const route = useRoute()
    return <Component {...props} route={route} ref={ref} />
  })

  hoistNonReactStatic(ComponentWithRoute, Component)
  ComponentWithRoute.displayName = `WithRoute(${getComponentName(Component)})`
  return ComponentWithRoute
}

export default withRoute

export const useSoftRoute = () => {
  const { route: initialRoute } = React.useContext(RouteContext)
  const [route, setRoute] = React.useState(initialRoute)

  React.useEffect(() => {
    const onRouteChangeStart = (url) => {
      setRoute(parseUrl({ url }))
    }
    return Router.subscribe(Router.events.routeChangeStart, onRouteChangeStart)
  }, [])

  return route
}

export const withSoftRoute = (Component) => {
  const ComponentWithSoftRoute = React.forwardRef((props, ref) => {
    const route = useSoftRoute()
    return <Component {...props} route={route} ref={ref} />
  })

  hoistNonReactStatic(ComponentWithSoftRoute, Component)
  ComponentWithSoftRoute.displayName = `WithSoftRoute(${getComponentName(Component)})`
  return ComponentWithSoftRoute
}
